import { render, staticRenderFns } from "./Reactivacion.vue?vue&type=template&id=526cf20a"
import script from "./Reactivacion.vue?vue&type=script&lang=ts"
export * from "./Reactivacion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports